export const DRAW_UPDATE_SOURCE_OPTION = {
  DOCUMENTATION: "DOCUMENTATION",
  DRAW_SUMMARY: "DRAW_SUMMARY",
};
